import React from 'react';
import clsx from 'clsx';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInputComponent.scss';

interface PhoneInputComponentProps {
    formik: any;
    fieldName: string;
    placeholder?: string;
    additionalClasses?: string;
    top?: number | string;
    left?: number | string;
    right?: number | string;
    bottom?: number | string;
    label: JSX.Element;
    defaultCountry?: string;
}

const PhoneInputComponent: React.FC<PhoneInputComponentProps> = (props: PhoneInputComponentProps): React.ReactElement => {
    const {
        formik,
        fieldName,
        placeholder,
        additionalClasses,
        label,
        top = '4.9rem',
        left = '0.7rem',
        right = 'unset',
        bottom = 'unset',
        defaultCountry = 'us',
    } = props;
    const value = formik.getFieldProps(fieldName).value;

    return (
        <div className={clsx('col-6 col-sm-4 col-md-3 fv-row input-container mb-5', additionalClasses)}>
            {label}
            <PhoneInput
                inputClass="mb-3 phone-input"
                buttonClass="phone-input-button"
                placeholder={placeholder ?? ''}
                value={value ?? ''}
                onChange={(number): void => formik.setFieldValue(fieldName, number)}
                country={defaultCountry}
                enableSearch
            />
            {formik.touched[fieldName] && formik.errors[fieldName] && (
                <div className="error-container" style={{ top, left, right, bottom }}>
                    <div className="text-danger fs-8">{formik.errors[fieldName]}</div>
                </div>
            )}
        </div>
    );
};

export default PhoneInputComponent;
